export default __webpack_public_path__ + "static/media/estetica_makup.8f7955b5.jpg";